import Daily from './Daily';

export default Daily;
